import { Action } from '../actions-manager/action';
import { MultiStageFlowAction } from '../actions-manager/multi-stage-flow-action';
import { ActionType } from '../actions-manager/server-requests-queue';
import { FlowActionGroup } from '../actions-manager/FlowActionGroup';
import { INetworkStore } from '~/types/dependency.types';

export type TMethod = 'create' | 'update' | 'delete';
type TItem = 'flow' | 'page' | 'block' | 'variable';
export type TSpecialAction = 'Group' | 'Stage' | 'Multi';

interface CommandsData {
    create: Array<string>;
    update: Array<string>;
    delete: Array<string>;
}

interface IActionLogProps {
    networkStore: INetworkStore;
}
export class ActionLog {
    networkStore: INetworkStore;
    actionType: string;
    commandsData: CommandsData = {
        create: [],
        update: [],
        delete: []
    };
    generalDataString: string;

    constructor({ networkStore }: IActionLogProps) {
        this.networkStore = networkStore;
    }

    addActionGeneralData(
        type: ActionType,
        action: Action,
        specialType: TSpecialAction = null
    ) {
        if (!action) {
            return;
        }

        const { action_number, appliedAt } = action;
        let { name } = action;

        const onlineStatus = this.networkStore.isOnline;

        const specialTypeString = this.getActionSpecialType(
            action,
            specialType
        );

        if (specialType === 'Stage') {
            const { lastAppliedStageName } =
                action as MultiStageFlowAction<any>;

            name = `${name} | ${lastAppliedStageName}`;
        }

        const actionNumberString =
            !action_number && action_number !== 0
                ? 'no action number'
                : action_number;
        this.generalDataString = `Action: ${type} | ${specialTypeString}${onlineStatus} | ${actionNumberString} | ${name} | ${appliedAt}`;
    }

    private getActionSpecialType(action: Action, specialType: string) {
        if (specialType) {
            return `${specialType} | `;
        }

        if (action instanceof FlowActionGroup) {
            return 'Group | ';
        }

        if (action instanceof MultiStageFlowAction) {
            return 'Multi | ';
        }

        return '';
    }

    addCommandData(
        itemType: TItem,
        method: TMethod,
        id: string,
        extraData: string = null
    ) {
        this.commandsData[method].push(
            `${method} ${itemType} ${extraData ? ` ${extraData} ` : ''}${id}`
        );
    }
}
